<div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
  <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
</div>
